import {
  Button,
  Col,
  Container,
  Image,
  InputGroup,
  Row,
  Alert,
  ButtonGroup,
  Modal,
  Card,
  Dropdown,
  Spinner,
} from 'react-bootstrap';
import genrateApps from './generateApps.module.scss';

import { useEffect, useReducer, useRef, useState } from 'react';
import axios from 'utils/axiosInstance';
import Form from '@rjsf/mui';
//import Form from '@rjsf/core';
import validator from '@rjsf/validator-ajv8';
import AccordionTemplate from './AccordionFormTemplateNew';
import DynamicAccordionPage from './DynamicAccordionForJsonData';
import RegenerateModalForm from './RegenerateModalForm';
import { IconButton } from 'rsuite';
import { Autorenew } from '@mui/icons-material';
import { Snackbar } from '@mui/material';
import { request } from '../../../request';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import GetAppIcon from '@mui/icons-material/GetApp';
function GenerateApps() {

  const EmptyTitleFieldTemplate = (props) => {
    return <></>; // Or return an empty div or any other desired element
  };

  const schema = {
    type: "object",
    properties: {
      section1: {
        title: "Business Information",
        type: "object",
        properties: {
          businessName: { type: "string", title: "Business Name" },
          businessCategory: { type: "string", title: "Business Category" },
          uspc: {
            type: "array",
            title: "About Company",
            items: {
              type: 'string'
            }
          }
        },
        required: ['businessName', 'businessCategory']
      },
      section2: {
        title: "Category/Offerings Information",
        type: "object",
        properties: {
          category: {
            type: "array",
            title: "Categories",
            items: {
              type: 'object',
              properties: {
                categoryName: {
                  type: "string",
                  title: "CategoryName"
                },
                offering: {
                  type: "array",
                  title: "Offering",
                  items: {
                    type: 'string'
                  }
                }
              }
            }
          }
          ,
          services: {
            type: "array",
            title: "Value Add Services",
            items: {
              type: 'string',
            }
          },
          processSteps: {
            type: "array",
            title: "Process Steps",
            items: {
              type: 'string'
            }
          },
          usps: {
            type: "array",
            title: "Unique qualities about services",
            items: {
              type: 'string'
            }
          }
        }

      }
    }
  };


  const uiSchema = {

    section1: {
      "ui:field": "accordion"
    },
    section2: {
      "ui:field": "accordion"
    }

  };

  const log = (type) => console.log.bind(console, type);

  const fields = {
    accordion: AccordionTemplate
  };


  const [jsonData, setJsonData] = useState(null);
  const [content, setContent] = useState(null);
  const [dropdownKeys, setDropdownKeys] = useState([]);
  const [selectedItem, setSelectedItem] = useState("");
  const [submittedData, setSubmittedData] = useState(null);
  const [error, setError] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const handleFormSubmit = async ({ formData }) => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setJsonData(null);
    setIsLoading(true);
    setSubmittedData(formData); // Store submitted data in state
    let jsonData = JSON.stringify(formData, null, 2)
    //console.log("user input data -> ", jsonData);
    const url = process.env.REACT_APP_STUDIO_BACKEND_API_URL + "v1/templates/app-template/generate-bestpractices-content";
    //await axios.post(
    const resp = await request.create({
      endPoint:url,
      jsonData:{
        actionType: "ALL",
        userFormPayload: jsonData
      }
    }
    )

    setIsLoading(false);
    //console.log("Form submission response data", resp);
    //setJsonData(resp?.data?.homePageGenAIObject)
    if(typeof resp === "undefined")
    {
      setError(true);
      //console.log("Error while calling API : ", error)
    }
    else{
      const content = resp?.content
      setContent(content);
      setDropdownKeys(Object.keys(content));
      setJsonData(content['Home']);
      setSelectedItem("Home");
    }
      
  };

  const handleSelect = (key) => {
    setSelectedItem(key);
    const jdata = key ? content[key] : "";
    setJsonData(jdata);

  };

  const [open, setOpen] = useState(false);

  const handleOpen = (event) => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  //const open = Boolean(anchorEl);

  const handleErrorClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setError(false);
  };

  const handleExport = ()=> {
    if(!content) return
    const formattedText = content?.Home?.pageName?.trim().toLowerCase().split(' ').join('-');
    const jsonContent = JSON.stringify(content, null, 2); 
    const blob = new Blob([jsonContent], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `genai-${formattedText}-data`;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
const handleFileUpload = (event) => {
  const file = event.target.files[0];
  if (file) {
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const data = JSON.parse(reader.result); 
        setContent(data);
        setDropdownKeys(Object.keys(data));
        setJsonData(data['Home']);
        setSelectedItem("Home");
        
      } catch (error) {
        console.error("Error parsing JSON file:", error);
        alert("Error parsing JSON file. Please ensure the file is a valid JSON.");
      }
    };
    reader.readAsText(file); 
  }
};

const triggerFileInput = () => {
  document.getElementById("fileInput").click(); 
};

  const scrollRef = useRef(null);

  return (
    <div style={{ minHeight: '100vh' }}>
      <Container fluid className={genrateApps.generateAppsHeader}>
        <Row className="ml-0 mr-0" style={{ height: '100%' }}>
          <Col
            md={12}
            style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}
          >
            <div
              className={genrateApps.generateAppsbackbtn}
              style={{ display: 'flex', paddingBottom: '10px', paddingLeft: '10px' }}
            >
              <span className={genrateApps?.title}>Generate Content</span>

            </div>
          </Col>
        </Row>
      </Container>

      <Row style={{ padding: 0, margin: 0, height: '100vh', overflowY: 'auto' }}>
        <Col md={6} style={{ paddingTop: 125, backgroundColor: '#ffff' }}>
          {/* <span className={genrateApps?.title} style={{ paddingLeft: 30 }}>
            Generate application using AI
          </span> */}
          <div style={{ padding: 30, width: '80%' }}>
            <Form
              schema={schema}
              uiSchema={uiSchema}
              validator={validator}
              onSubmit={handleFormSubmit}
              onError={log('errors')}
              fields={fields}
            />
          </div>
        </Col>
        <Col
          ref={scrollRef}
          md={6}
          style={{
            paddingTop: '80px',
            backgroundColor: 'white',
            overflowY: 'auto',
          }}
        >
          <Row>
            <Col>
              <Dropdown >
                <Dropdown.Toggle
                  id="dropdown-basic"
                  style={{
                    marginBottom: '20px',
                    width: '200px',
                    display: 'flex',
                    alignItems: 'center',
                    paddingRight: '10px',
                    paddingLeft: '15px',
                    justifyContent: 'space-between',
                    backgroundColor: '#F3F5F7',
                    color: '#000000',
                    border: 'none',
                    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.25)',
                  }}
                >
                  {selectedItem || "Select Page"}
                  <span className="icon-ico_down-arrow-1 align-right ml-2"></span>
                </Dropdown.Toggle>

                <Dropdown.Menu style={{ width: '200px' }}>
                  {dropdownKeys.map((key) => (
                    <Dropdown.Item
                      key={key}
                      onClick={() => handleSelect(key)}
                    >
                      {key}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col className=''>
            <Button onClick={handleExport} className='mr-5' title='export'><FileUploadIcon /></Button>
            <Button  onClick={triggerFileInput} className='mr-5' title='import'><GetAppIcon /></Button>
            <input
              id="fileInput"
              type="file"
              accept="application/json"
              onChange={handleFileUpload}
              style={{ display: "none" }}
            />
            <Button title='regenerate'  onClick={handleOpen}>
            <Autorenew />
            </Button>
              <RegenerateModalForm open={open} onClose={handleClose} userInputData={submittedData} />
            </Col>
          </Row>
          <Row>
            <Snackbar open={error} autoHideDuration={6000} onClose={handleErrorClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
              <Alert onClose={handleErrorClose} severity="error" sx={{ width: '100%' }}>
                Failed to fetch data. Please try again later. If error continues please reach support team.
              </Alert>
            </Snackbar>
            <div
              style={{
                borderRadius: '8px',
                backgroundColor: '#F3F5F7',
                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
              }}
            >


              {isLoading && <Row style={{ display: 'flex', justifyContent: 'center', padding: "100px" }}> <Spinner style={{ margin: '10px' }} /></Row>}
              <Row> {jsonData && <DynamicAccordionPage data={jsonData} userInputData={submittedData} />}</Row>
            </div>
          </Row>
        </Col>
      </Row>
    </div>
  );
}
export default GenerateApps;
